module.exports = __webpack_public_path__ + "ad4a156d08f33513d921c5d1814379b8.svg";